export default function imageBlock(videoPart, $) {

    const iframe = videoPart.querySelector('iframe')

    $(window).on("load resize orientationchange", () => adjustBackgroundVideoAR())

    function adjustBackgroundVideoAR() {
        let slideRatio = iframe.getAttribute('width') / iframe.getAttribute('height'),
            diff = Math.abs((16 / 6) - slideRatio)
        iframe.style.transform = `scale(${1 + diff})`
    }

}
